import { cn } from '#app/utils/misc.tsx'

/**
 * Status pills — status always has text. `done` = green pill (afgesproken,
 * actief), `warm` = the one warning signal (vraagt een keuze), `muted` =
 * gepland / beschermd, `accent` = an appointment tag. `dot` draws the 7px
 * green dot in front (weeklink actief).
 */
export function OyPill({
	tone,
	dot,
	className,
	children,
}: {
	tone: 'done' | 'warm' | 'muted' | 'accent' | 'ink'
	dot?: boolean
	className?: string
	children: React.ReactNode
}) {
	return (
		<span className={cn('oy-pill', `oy-pill-${tone}`, className)}>
			{dot ? <i className="oy-pill-dot" aria-hidden="true" /> : null}
			{children}
		</span>
	)
}
